import React, { useEffect } from "react";
import ProfileIcon from './ProfileIcon';
import square_cat from "../../assets/glip_square.svg";


export default function ProfileDownloadIcon({ img }){
    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <ProfileIcon style={{zIndex: 5, position: 'relative'}} img={img}></ProfileIcon>
        <img
          style={{
            position: "relative",
            top: 0,
            height: 36,
            width: 36,
            left: -6,
            // marginBottom: 16,
            zIndex: 0
          }}
          src={square_cat}
        />
      </div>
    );
  };